// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/CheckSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareTwoToneSvg
  }));
};

CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
export default React.forwardRef(CheckSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CheckSquareTwoTone.js
// module id = 759
// module chunks = 0